import { useContext } from 'react';
import AudioElementContext from '@/contexts/audio-playback/audio-element';

const useAudioElement = () => {
  const value = useContext(AudioElementContext);

  return value;
};

export default useAudioElement;